export const OPT_IN_ALL_EVENT = "RCB/OptIn/All";